var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-pond',{ref:"pond",attrs:{"name":"logo","label-idle":"Clicca o trascina qui il logo…","accepted-file-types":"image/gif, image/jpeg, image/png","credits":"false","allow-multiple":false,"files":_vm.uploads,"server":_vm.serverUrl},on:{"processfile":_vm.handleProcessFile,"removefile":_vm.handleRemoveFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }